import PropTypes from 'prop-types'
import React, { memo, useState } from 'react'

import { HeaderCenterWrapper } from './style'
import IconSearch from '@/assets/svg/IconSearch'
import SearchTabs from './cpns/SearchTabs'
import searchData from '@/assets/data/search.json'
import SearchPanel from './cpns/SearchPanel'
import { CSSTransition } from 'react-transition-group'

const HeaderCenter = memo((props) => {
  // 属性
  const { isSearch, changeIsSearch } = props

  /* 激活状态的搜索栏 */
  const tabs = searchData.map((item) => item.title)
  const [currIndex, setCurrIndex] = useState(0)

  function changeIndex(index) {
    setCurrIndex(index)
  }

  /* 切换正常搜索、激活状态的搜索栏 */
  function switchIsSearch(flag) {
    if (changeIsSearch) changeIsSearch(flag)
  }

  return (
    <HeaderCenterWrapper>
      {/* {!isSearch ? (
        <div className="search-base" onClick={(e) => switchIsSearch(true)}>
          <div className="text">搜索房源和体验</div>
          <div className="search">
            <IconSearch />
          </div>
        </div>
      ) : (
        <div className="search-active">
          <div className="search-tabs">
            <SearchTabs tabs={tabs} activeIndex={currIndex} changeIndex={changeIndex} />
          </div>
          <div className="search-panel-wrap">
            <SearchPanel searchInfos={searchData[currIndex].searchInfos} />
          </div>
        </div>
      )} */}


      {/* 正常搜索栏 */}
      <CSSTransition classNames="base" timeout={250} in={!isSearch} unmountOnExit={true}>
        <div className="search-base" onClick={(e) => switchIsSearch(true)}>
          <div className="text">搜索房源和体验</div>
          <div className="search">
            <IconSearch />
          </div>
        </div>
      </CSSTransition>

      {/* 激活状态的搜索栏 */}
      <CSSTransition classNames="active" timeout={250} in={isSearch} unmountOnExit={true}>
        <div className="search-active">
          <div className="search-tabs">
            <SearchTabs tabs={tabs} activeIndex={currIndex} changeIndex={changeIndex} />
          </div>
          <div className="search-panel-wrap">
            <SearchPanel searchInfos={searchData[currIndex].searchInfos} />
          </div>
        </div>
      </CSSTransition>
    </HeaderCenterWrapper>
  )
})

HeaderCenter.propTypes = {
  isSearch: PropTypes.bool,
  changeIsSearch: PropTypes.func
}

export default HeaderCenter
